import type { CombatManager } from "./CombatManager.js";

/**
 * Engine-wide singleton reference to the active `CombatManager`.
 *
 * `main.tsx` constructs a new CombatManager per map load; it calls
 * `setCombatManager(cm)` after wiring. The UI layer (PartyBar ATB fill,
 * EnemyMeter) reads the active instance via `getCombatManager()` so the
 * HUD keeps working across level transitions without prop-drilling.
 *
 * Tests construct their own CombatManager with `new` and do not touch
 * this module — the singleton is purely for runtime UI wiring.
 */

let _combatManager: CombatManager | null = null;

export function setCombatManager(cm: CombatManager | null): void {
  _combatManager = cm;
}

export function getCombatManager(): CombatManager | null {
  return _combatManager;
}
